import {useEffect, useState} from "react";
import FormInputs from "../../FormInputs";
import {getBillingSettings, updateBillingSettings} from "../../../api/admin/billingReq";
import useData from "../../../hooks/useData";
import useAuth from "../../../hooks/useAuth";
import FormButtons from "../../../components/common/FormButtons";
import {
    checkRequiredFields,
    getErrorListFromValidation, normalizeZipCode,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../../helper/tools";

export default function FormBillingSettings({ legend, setShowModal, apiSettingsInfos }) {

    const { billingSettings, setBillingSettings} = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const [values, setValues] = useState(billingSettings);

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        validateFormInput(e)
    };

    const apiBillingSettings = async () => {
        const response = await getBillingSettings(token)
        setBillingSettings(response)
    }

    useEffect(() => {
        apiBillingSettings();
    }, []);

    useEffect(() => {
        setValues(billingSettings)
    }, [ billingSettings ]);


    const inputs = [
        {
            id : 1,
            name : "name",
            type : "text",
            placeholder : "Nom de la société",
            label : "Nom de la société",
            pattern : patternListChoices?.name
        },
        {
            id : 6,
            name : "phone",
            type : "text",
            placeholder : "Téléphone",
            label : "Téléphone",
            pattern : patternListChoices?.phone
        },
        {
            id : 7,
            name : "email",
            type : "email",
            placeholder : "Email",
            label : "Email",
            required : true,
        },
        {
            id : 1,
            name : "address",
            type : "text",
            placeholder : "Adresse postale",
            label : "Adresse postale",
            pattern: patternListChoices?.address
        },
        {
            id : 12,
            name : "addressComp",
            type : "text",
            placeholder : "Complément d'adresse",
            label : "Complément d'adresse",
            pattern: patternListChoices?.address
        },
        {
            id : 2,
            name : "zipcode",
            type : "text",
            placeholder : "Code postal",
            pattern: patternListChoices?.zip,
            label : "Code postal",
        },
        {
            id : 3,
            name : "city",
            type : "text",
            placeholder : "Ville",
            label : "Ville",
            pattern: patternListChoices?.city
        },
        {
            id : 4,
            name : "legalForm",
            type : "text",
            placeholder : "Forme juridique",
            label : "Forme juridique",
        },
        {
            id : 8,
            name : "capital",
            type : "text",
            placeholder : "Capital",
            label : "Capital",
            pattern: patternListChoices?.num
        },
        {
            id : 9,
            name : "siren",
            type : "text",
            placeholder : "Siren",
            label : "Siren",
            pattern: patternListChoices?.siren
        },
        {
            id : 12,
            name : "rcsCity",
            type : "text",
            placeholder : "RCS (ville)",
            label : "RCS (ville)",
            pattern : patternListChoices?.alphaNum
        },
        {
            id : 13,
            name : "orias",
            type : "text",
            placeholder : "Numéro ORIAS",
            label : "Numéro ORIAS",
            pattern: patternListChoices?.orias
        },
        {
            id : 11,
            name : "tvaIntra",
            type : "text",
            placeholder : "TVA intracommunautaire",
            label : "TVA intracommunautaire",
            pattern: patternListChoices?.tvaIntra
        },
        {
            id : 14,
            name : "tvaRate",
            type : "text",
            placeholder : "Taux TVA",
            label : "Taux TVA",
            pattern: patternListChoices?.price
        },
        {
            id : 17,
            name : "account",
            type : "text",
            placeholder : "Compte",
            label : "Compte",
            pattern: "^[0-9]{11}$",

        },
        {
            id : 15,
            name : "ribKey",
            type : "text",
            placeholder : "RIB",
            label : "Clé RIB",
            pattern: "^[0-9]{2}$",
        },
        {
            id : 16,
            name : "iban",
            type : "text",
            placeholder : "IBAN",
            label : "IBAN",
            pattern: "^[A-Z]{2}\\d{2}( ?\\d{4}){5}( ?\\d{1,3}){0,1}$",
        },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!checkRequiredFields()) {
            return;
        }
        e.preventDefault()
        let body = {
            name : values?.name,
            phone : values?.phone,
            email : values?.email,
            address : values?.address,
            addressComp : values?.addressComp ? values?.addressComp : null,
            zipcode : normalizeZipCode(values?.zipcode),
            city : values?.city,
            legalForm : values?.legalForm,
            capital : values?.capital,
            siren : values?.siren,
            rcsCity : values?.rcsCity,
            ape : values?.ape,
            orias : values?.orias,
            tvaIntra : values?.tvaIntra,
            tvaRate : (values?.tvaRate).toString(),
            account : values?.account,
            ribKey : values?.ribKey,
            iban : values?.iban,
        }

        await updateBillingSettings(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiSettingsInfos();
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    return (
        <form onSubmit={handleSubmit} method="post" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <legend>{legend}</legend>}
                {inputs.map(input =>(
                    <FormInputs
                        type={ input.type }
                        name={ input.name }
                        id={ input.id }
                        label={input.label}
                        placeholder={ input.placeholder }
                        value={ values[input.name] }
                        onChange={ onChange }
                        required={ input.required }
                        options={ input.options }
                        checked={ input.checked }
                        key={ input.id+input.name }
                        pattern={ input.pattern }
                    />
                ))}
            <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}